<template>
  <div v-if="showModal" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity" aria-hidden="true">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
        <div class="bg-white px-4 !p-8 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start justify-center">
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
              <h3 class="text-lg leading-6 font-medium text-gray-900 pt-0 !pb-2" id="modal-title">
                {{ modalAction === 'delete' ? 'Delete Banner' : 'Update Banner' }}
              </h3>
              <div class="mt-2">

                <!-- Delete Options -->
                <p v-if="modalAction === 'delete'" class="text-sm text-gray-500 mb-4">
                  Do you want to delete this banner or all related banners?
                </p>
                <div v-if="modalAction === 'delete'">
                  <div class="flex items-center mb-4">
                    <input checked id="delete_self" type="radio" value="0" name="apply_to_descendants" @change="updateApplyToDescendants(false)" class="w-4 h-4 mt-0 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 focus:ring-2">
                    <label for="delete_self" class="ms-2 text-sm font-medium text-gray-900 mb-0">Delete this banner only</label>
                  </div>
                  <div class="flex items-center">
                    <input id="delete_self_and_descendants" type="radio" value="1" name="apply_to_descendants" @change="updateApplyToDescendants(true)" class="w-4 h-4 mt-0 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 focus:ring-2">
                    <label for="delete_self_and_descendants" class="ms-2 text-sm font-medium text-gray-900 mb-0">Delete this banner and all related</label>
                  </div>
                </div>

                <!-- Update Options -->
                <p v-if="modalAction === 'update'" class="text-sm text-gray-500 mb-4">
                  Do you want to update this banner or all related banners?
                </p>
                <div v-if="modalAction === 'update'">
                  <div class="flex items-center mb-4">
                    <input checked id="update_self" type="radio" value="0" name="apply_to_descendants" @change="updateApplyToDescendants(false)" class="w-4 h-4 mt-0 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 focus:ring-2">
                    <label for="update_self" class="ms-2 text-sm font-medium text-gray-900 mb-0">Update this banner only</label>
                  </div>
                  <div class="flex items-center">
                    <input id="update_self_and_descendants" type="radio" value="1" name="apply_to_descendants" @change="updateApplyToDescendants(true)" class="w-4 h-4 mt-0 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 focus:ring-2">
                    <label for="update_self_and_descendants" class="ms-2 text-sm font-medium text-gray-900 mb-0">Update this banner and all related</label>
                  </div>
                </div>

                <input type="hidden" name="apply_to_descendants" :value="form.apply_to_descendants">

              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <!-- Delete Button -->
          <button v-if="modalAction === 'delete'" @click="deleteBanner()" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm">
            Delete
          </button>

          <!-- Update Button -->
          <button v-if="modalAction === 'update'" @click="updateBanner()" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm">
            Save
          </button>

          <button @click="showModal = false" type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">

    <sonicu-header>
      Edit Banner
    </sonicu-header>

    <div class="md:grid md:grid-cols-3 md:gap-6">

      <div class="md:col-span-1">
        <div class="px-4 sm:px-0">
          <span class="text-lg font-medium leading-6 text-gray-900">
            Companies
          </span>
          <p class="mt-1 text-sm leading-5 text-gray-600">
            Select the company for which you would like to create a banner.
          </p>
        </div>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-2">
        <div class="shadow overflow-hidden sm:rounded-md">
          <div class="px-4 py-5 bg-white sm:p-6">
            <div class="grid max-w-2xl grid-cols-4 gap-x-6 gap-y-8">
              <div class="mb-6 col-span-4">
                <label for="company" class="block mb-2 text-sm font-medium text-gray-900">
                  Company
                </label>
                <select v-model="form.company_id" id="company" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" disabled>
                  <option :value="company.id" :key="company.id">{{ company.name }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="md:col-span-1">
        <div class="px-4 sm:px-0">
          <span class="text-lg font-medium leading-6 text-gray-900">
            Banner Message
          </span>
          <p class="mt-1 text-sm leading-5 text-gray-600">
            Enter the message that will be displayed on the banner.
          </p>
        </div>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-2">
        <div class="shadow overflow-hidden sm:rounded-md">
          <div class="px-4 py-5 bg-white sm:p-6">
            <div class="grid max-w-2xl grid-cols-4 gap-x-6 gap-y-8">
              <div class="mb-6 col-span-4">
                <label for="banner_message" class="block mb-2 text-sm font-medium text-gray-900">
                  Banner Message
                </label>
                <input v-model="form.banner_message" type="text" id="banner_message" placeholder="Enter a message" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="md:col-span-1">
        <div class="px-4 sm:px-0">
          <span class="text-lg font-medium leading-6 text-gray-900">
            Banner Link
          </span>
          <p class="mt-1 text-sm leading-5 text-gray-600">
            Enter the link that the banner will redirect to.
          </p>
        </div>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-2">
        <div class="shadow overflow-hidden sm:rounded-md">
          <div class="px-4 py-5 bg-white sm:p-6">
            <div class="grid max-w-2xl grid-cols-4 gap-x-6 gap-y-8">
              <div class="mb-6 col-span-4">
                <label for="banner_link" class="block mb-2 text-sm font-medium text-gray-900">
                  Banner Link
                </label>
                <input v-model="form.banner_link" type="text" id="banner_link" placeholder="https://sonicu.com/support" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5">
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="flex justify-end pt-5">
      <button @click="showModal = true; modalAction = 'update'" type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 focus:outline-none">Save Changes</button>
      <a href="/SonicuTools/banners" class="hover:text-gray-900 hover:no-underline focus:no-underline active:no-underline text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2">Cancel</a>
      <button @click="showModal = true; modalAction = 'delete'" type="button" class="text-red-700 hover:text-white border border-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">Delete Banner</button>
    </div>
  </div>
</template>

<script>
import SonicuHeader from "../elements/SonicuHeader.vue";
import ButtonRedPrimary from "../elements/buttons/ButtonRedPrimary.vue";
import axios from "axios";

export default {
  name: 'BannerCreate',
  components: {ButtonRedPrimary, SonicuHeader},
  props: {
    banner: {
      type: Object,
      required: true
    },
    company: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      form: {
        company_id: this.company.id,
        banner_message: this.banner.global_status_banner,
        banner_link: this.banner.global_status_banner_link,
        apply_to_descendants: false,
      },
      showModal: false,
      modalAction: '',
    }
  },
  methods: {
    updateApplyToDescendants(value) {
      this.form.apply_to_descendants = value;
      console.log(this.form.apply_to_descendants);
    },
    deleteBanner() {
      this.showModal = false;
      axios.delete('/api-internal/SonicuTools/banners/' + this.company.id, {data: this.form})
          .then(response => {
            window.location.href = '/SonicuTools/banners';
          })
          .catch(error => {
            console.log(error);
          });
    },
    updateBanner() {
      this.showModal = false;
      axios.post('/api-internal/SonicuTools/banners/' + this.company.id, this.form)
          .then(response => {
            window.location.href = '/SonicuTools/banners';
          })
          .catch(error => {
            console.log(error);
          });
    }
  }
}
</script>
